import { useCreateMacroData } from '../CreateMacroDataProvider'
import { Breadcrumb, Button, Divider, Input, Popover, Checkbox, Form, Select, Radio, InputNumber, Switch } from 'antd'
import CreateFormConfig from './CreateFormConfig'
import DateRangeConfig from './DateRangeConfig'
import DateTimeConfig from './DateTimeConfig'
import QueryConfig from './QueryConfig'
import RadioOptionsConfig from './RadioOptionsConfig'
import RelationConfig from './RelationConfig'
import SwitchLabelConfig from './SwitchLabelConfig'
import FormLikeField from './FormLikeField'
import { componentTypes, specialFields } from '../constants'
import { setFieldData } from '../CreateMacroDataProvider/actions'

getStringFieldDefaultValue = (defaultValue) ->
  if not defaultValue?
      ''
  else if defaultValue is true or defaultValue is false
      ''
  else if _.isNumber(defaultValue) or _.isFinite(defaultValue)
      ''
  else
      defaultValue

getNumberFieldDefaultValue = (defaultValue) ->
  if _.isNumber(defaultValue) or _.isFinite(defaultValue)
      defaultValue
  else
      undefined

getSwitchFieldDefaultValue = (defaultValue) ->
  if not defaultValue?
      false
  else if defaultValue is true
      true
  else if defaultValue is false
      false
  else
      false

DefaultFieldValue = ({ fieldKey }) ->
  [{ fieldData }, dispatch] = useCreateMacroData()

  setFieldProperty = (
        propKey,
        selector = ((sel) ->
            if sel.target?
                sel.target.value
            else
                sel
        )
  ) -> (value) ->
    dispatch(
        setFieldData(
            _.set(fieldData, [fieldKey, propKey], selector(value))
        )
    )

  return null unless fieldData[fieldKey]

  (switch fieldData[fieldKey].type
    when componentTypes.default.string
      <FormLikeField label="Default Value">
        <Input
            value={getStringFieldDefaultValue(fieldData[fieldKey].default)}
            key={fieldKey}
            onChange={(e) ->
                setFieldProperty('default')(e)
            }
        />
      </FormLikeField>
    when componentTypes.default.number
      <FormLikeField label="Default Value">
        <InputNumber
            value={getNumberFieldDefaultValue(fieldData[fieldKey].default)}
            key={fieldKey}
            onChange={(e) ->
                setFieldProperty('default')(e)
            }
        />
      </FormLikeField>
    when componentTypes.default.switch
      <FormLikeField label="Default Value">
        <Switch
            checked={getSwitchFieldDefaultValue(fieldData[fieldKey].default)}
            key={fieldKey}
            onChange={(e) ->
                setFieldProperty('default')(e)
            }
        />
      </FormLikeField>
    else
      <div key="#{fieldKey}-undefined-config-default"/>
  )

export default DefaultFieldValue
